<template lang="pug">
.timetable-view
  .timetable-main(v-if="courses.length")
    .timetable-item(v-for="(course, index) in courses")
      .item-time-box
        .item-time {{ course.start_time }}
      .item-content-box
        //- 空心
        .item-point(
          v-if="!course.is_started && !course.is_expired",
          v-bind:class="course.course_lang === 'en' ? 'point-purple-border' : course.course_lang === 'ja' ? 'point-orange-border' : 'point-green-border'"
        )
        //- 實心
        .item-point(
          v-else,
          v-bind:class="course.course_lang === 'en' ? 'point-purple' : course.course_lang === 'ja' ? 'point-orange' : 'point-green'"
        )
        .item-title 
          span {{ course.title }}
          span(v-if="course.course_watchtype === 'meeting'") {{ ' - ' }} (互動)
          span(v-if="course.course_watchtype === 'live'") {{ ' - ' }} (直播)
        .clearfix

        //- 課程時間
        .item-time
          span {{ course.start_time }}, {{ course.course_minutes }} min
        //- 課程老師
        .item-teacher
          span {{ course.coures_teacher.name }}

        .clearfix

        //- 課程類型
        .item-personal
          img.per-img(src="@/assets/images/desk-chair@3x.png")
          .per-text
            span(v-if="course.course_type === 'PS'") 個人
            span(v-else) 團班
          .clearfix

        //- 語言別
        .item-language
          img.lan-img(src="@/assets/images/lan.png")
          .lan-text
            span(v-if="course.course_lang === 'en'") 美語
            span(v-if="course.course_lang === 'ja'") 日語
            span(v-if="course.course_lang === 'ka'") 韓語
          .clearfix

        .clearfix

        //- 進入課堂
        .item-enter-box.click-cursor
          .item-enter.item-enter-b(
            v-if="course.is_started && !course.is_expired"
          )
            .item-enter-button(@click="$root.enterCourse(course.course_id)") 進入課堂
          .item-enter.item-enter-g(v-else)
            .item-enter-button 進入課堂
      .clearfix
  .timetable-main(v-else)
    .nottime 這裏沒有安排課程喔
</template> 

<script>
// import $ from 'jquery'
export default {
  props: ['use_type'],
  data () {
    return {
      courses: [],
    }
  },
  created () {
    setTimeout(() => { this.getStudentCourse() }, 250)
  },
  watch: {

  },
  methods: {
    // 依據不同情境調閱課程資料
    getStudentCourse () {
      // 獲取未來的課程列表
      if (this.use_type === 'home') {
        console.log('--==>  開始獲取未來的課程列表...')
        this.getStudentCourseList('all', 'all', this.$root.date_filter)
      }
      // 獲取今日的課程列表
      if (this.use_type === 'history-today') {
        this.getStudentTodayCourseList(this.language_filter, this.class_filter, this.date_filter)
      }
      // 獲取昨日的課程列表
      if (this.use_type === 'history-yesterday') {
        this.getStudentTodayCourseList(this.language_filter, this.class_filter, this.date_filter)
      }
    },
    // 獲取未來的課程列表
    async getStudentCourseList (_courseLang, _courseType, _courseDate) {
      // 獲取學員課程資料
      await this.$root.apis.getStudentCourseList(_courseLang, _courseType, _courseDate, this.processCourseListSuccess, this.processCourseListError)
    },
    // 獲得今日的課程列表
    async getStudentTodayCourseList (_courseLang, _courseType, _courseDate) {
      // 開啟載入頁
      this.$root.useLoading()
      // 獲取學員課程資料
      await this.$root.apis.getStudentTodayCourseList(_courseLang, _courseType, _courseDate, this.processCourseListSuccess, this.processCourseListError)
      // 關閉載入頁
      this.$root.closeLoading()
    },
    // 獲得昨日的課程列表
    // async getStudentOldCourseList (_courseLang, _courseType, _courseDate) {
    // },
    // 處理獲得的課程列表資料
    processCourseListSuccess (_response) {
      if (_response.body.error_code !== 0) {
        return this.processCourseListError(_response)
      }
      // 處理課程列表資料
      let courses = _response.body.data
      // 更新畫面資料
      this.courses = courses
      // 獲取課程資料結束
      console.log('--==>  成功獲取課程資料...')
    },
    // 處理失敗的課程列表資料
    processCourseListError () {

    },
  }
}
</script>
<style lang="sass" scoped>
.timetable-view
  width: 100%
  .timetable-main
    margin-top: 1rem
    .nottime
      padding-top: 17rem
      color: #191d35
      font-size: 1rem
      font-weight: 500
      line-height: 3rem
      text-align: center
    .timetable-item
      margin: 0 0 1rem 0
      position: relative
      &:last-child .item-content-box
        border-bottom: 1px solid rgba(0,0,0,0)
      .item-time-box
        width: 2rem
        text-align: left
        float: left
        font-size: .8rem
        line-height: 1.7rem
        font-weight: 500
        color: #191d35
        margin-right: 1rem

      .item-content-box
        padding-right: .4rem
        width: calc(100% - 3rem)
        float: left
        border-bottom: 1px solid #d8d8d8
        padding-bottom: .7rem

        .item-point
          float: left
          border-radius: 50%
        .point-purple
          background: #8086ff
          width: .8rem
          height: .8rem
          margin: .8rem .8rem .8rem .3rem
        .point-green
          background: #49b583
          width: .8rem
          height: .8rem
          margin: .8rem .8rem .8rem .3rem
        .point-orange
          background: #ffbd69
          width: .8rem
          height: .8rem
          margin: .8rem .8rem .8rem .3rem
        .point-purple-border
          border: 3px solid #8086ff
          width: calc(.8rem - 4px)
          height: calc(.8rem - 4px)
          margin: .5rem .8rem .8rem .3rem
        .point-green-border
          border: 3px solid #49b583
          width: calc(.8rem - 4px)
          height: calc(.8rem - 4px)
          margin: .5rem .8rem .8rem .3rem
        .point-orange-border
          border: 3px solid #ffbd69
          width: calc(.8rem - 4px)
          height: calc(.8rem - 4px)
          margin: .5rem .8rem .8rem .3rem
        .item-title
          width: calc(100% - 2rem)
          float: left
          color: #191d35
          font-size: .8rem
          font-weight: 500
          text-align: justify
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          white-space: normal
          margin-top: .14rem
          line-height: 1.3rem
        .item-time
          float: left
          padding-right: .5rem
          margin-left: 1.7rem
          border-right: 1px solid #191d35
          color: #191d35
          font-size: .8rem
          line-height: 1rem
          margin-top: .5rem
          margin-bottom: 1rem
          line-height: 1.1rem
          font-weight: 500
        .item-teacher
          font-size: .8rem
          line-height: 1rem
          color: #191d35
          float: left
          margin-left: .5rem
          margin-top: .5rem
          margin-bottom: 1rem
          line-height: 1.1rem
          font-weight: 500
        .item-language
          text-align: left
          margin: .5rem 1rem .5rem 0rem
          float: left
          .lan-text
            float: left
            font-size: .8rem
            line-height: 1.4rem
            span
              color: #91a1c1
          img.lan-img
            float: left
            height: 1rem
            margin: .2rem .3rem .2rem .2rem
        .item-personal
          text-align: left
          float: left
          margin: .5rem .5rem .5rem 1.7rem
          .per-text
            float: left
            font-size: .8rem
            line-height: 1.4rem
            span
              color: #91a1c1
          img.per-img
            float: left
            height: 1rem
            margin: .2rem .3rem .2rem .2rem
        .item-enter-b
          background: #2e50ff
        .item-enter-g
          background: #c7c7c7
        .item-enter
          position: absolute
          right: 0rem
          bottom: 1rem
          border-radius: 24px
          font-size: .8rem
          &:active
            opacity: .6
          .item-enter-button
            color: #fff
            padding: .5rem 1rem
</style>
